//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export enum EXIT_CONFIRMATION_MODAL_ACTIONS {
  OPEN_MODAL = 'EXIT_CONFIRMATION_MODAL_ACTIONS/OPEN_MODAL',
  CLOSE_MODAL = 'EXIT_CONFIRMATION_MODAL_ACTIONS/CLOSE_MODAL',
}
